import { FC, SyntheticEvent, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MainLayout from 'src/pages/private';
import { ProfileTab } from 'src/components/SettingsTab/ProfileTab';
import { CompanyTab } from 'src/components/SettingsTab/CompanyTab';
import CustomTabs from 'src/components/StyledComponents/StyledTab';
import { fetchCurrentUserRole } from 'src/utils/user.utils';
import StyledSnackbar from 'src/components/StyledComponents/StyledSnackBar';
import { getApiErrorMessage } from 'src/utils/errorHandler';
import {
  OverflowContainer,
  JustifyStartContainer,
} from 'src/components/StyledComponents/StyledPageComponents';

const Settings: FC = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [isOwner, setIsOwner] = useState(false);
  const navigate = useNavigate();
  const { showSnackbar } = StyledSnackbar();

  useEffect(() => {
    const checkUserRole = async () => {
      try {
        const isOwner = await fetchCurrentUserRole();
        setIsOwner(isOwner);
      } catch (e) {
        const errorMessage = await getApiErrorMessage(e);
        showSnackbar(errorMessage, 'error');
      }
    };

    checkUserRole();
  }, [navigate]);

  const handleTabChange = (event: SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <MainLayout title="Settings">
      <Box display="flex">
        <OverflowContainer flexGrow={1} display="flex" flexDirection="column">
          <JustifyStartContainer display="flex">
            <CustomTabs
              selectedTab={selectedTab}
              handleTabChange={handleTabChange}
              isOwner={isOwner}
            />

            <Box flexGrow={1}>
              {selectedTab === 0 && <ProfileTab />}
              {selectedTab === 1 && <CompanyTab />}
            </Box>
          </JustifyStartContainer>
        </OverflowContainer>
      </Box>
    </MainLayout>
  );
};

export default Settings;
